module.exports = {
    Bible: require('./bible.json'),
    'Bible - Difficult': require('./bible-difficult.json'),
    Standard: require('./standard.json')
}
